/** 
 * @type {import("./defs").StorePlanProjectWeight} 
 */
const store = {
}
/** 
* @returns {import("./defs").StorePlanProjectWeight} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StorePlanProjectWeight.js